function removeChars(str, numberOfCharactersToRemove) {
    if(str != null && str.trim() !== '') {
        return str.substring(0, str.length - numberOfCharactersToRemove);
    }
    return "";
}

export default function phoneNumberOnly( value) {
    let NumberOnlyValue = value ? value: '';
    NumberOnlyValue = NumberOnlyValue.replace(/\D/g, "");
    if(NumberOnlyValue.length > 10){
       NumberOnlyValue = removeChars(NumberOnlyValue, 1);
    }
    NumberOnlyValue = NumberOnlyValue.replace(
      /^(\d{3})(\d{3})(\d+)$/,
      "($1) $2-$3"
    );
   return NumberOnlyValue
  }